import { useBreakpoint } from 'hooks/useBreakpoint';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import { useSafeSearchParams } from '../../../../../hooks/useSafeSearchParams/useSafeSearchParams';
import { cmsQueryParamsPrefix } from '../../helpers/types';

export const useTab = (tabs: string[] = []) => {
  const tabQueryParam = `${cmsQueryParamsPrefix}activeTab`;
  const version = useBreakpoint({
    _: { mobile: true },
    md: { mobile: false },
  });

  const pathname = usePathname();
  const searchParams = useSafeSearchParams();
  const activeTab = searchParams?.get(tabQueryParam);

  const activeTabInfo = useMemo(() => {
    if (!tabs?.length) {
      return null;
    }
    if (!activeTab) {
      return tabs[0];
    }
    return tabs.find((i, index) => index + 1 === +activeTab);
  }, [activeTab, tabs]);

  const onSetNewActiveTab = (index: number) => {
    const paramsFromLocation = new URLSearchParams(window.location.search);
    paramsFromLocation.set(tabQueryParam, (index + 1).toString());
    const url = `${pathname}?${paramsFromLocation.toString()}`;
    window.history.pushState(null, '', url);
  };

  return {
    activeTab,
    activeTabInfo,
    onSetNewActiveTab,
    version,
  };
};
